var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 21.3333L28 16L22.6667 14.8147M22.6667 14.8147L16 13.3333M22.6667 14.8147L24 8H18.6667M16 13.3333V20M16 13.3333L9.33333 14.8147M9.33333 14.8147L4 16L6.66667 21.3333M9.33333 14.8147L8 8H13.3333M13.3333 8V4H18.6667V8M13.3333 8H18.6667M4 26.6667L5.66 26.0027C6.1761 25.7963 6.73466 25.7185 7.2875 25.7761C7.84034 25.8337 8.37087 26.025 8.83333 26.3333C9.52512 26.7946 10.361 26.9886 11.1853 26.8792C12.0095 26.7698 12.7658 26.3644 13.3133 25.7387L13.36 25.6853C13.6891 25.3089 14.095 25.0071 14.5503 24.8004C15.0057 24.5937 15.4999 24.4867 16 24.4867C16.5001 24.4867 16.9943 24.5937 17.4497 24.8004C17.905 25.0071 18.3109 25.3089 18.64 25.6853L18.688 25.7387C19.2355 26.3644 19.9918 26.7698 20.8161 26.8792C21.6403 26.9886 22.4762 26.7946 23.168 26.3333C23.6305 26.025 24.161 25.8337 24.7138 25.7761C25.2667 25.7185 25.8252 25.7963 26.3413 26.0027L28 26.6667",
    stroke: "#58486C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.5ada473f1d84561c48953a6f0b29d611.svg";
export { ForwardRef as ReactComponent };